import { Typography } from 'antd';

export const Title = ({ children, style }) => (
    <Typography.Title level={4} style={{ color: '#4d525b', marginTop: 0, ...style }}>{children}</Typography.Title>
)